import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert } from 'antd';
import { Link } from 'react-router-dom';
import { UserOutlined, MailOutlined, LockOutlined, ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const Register = () => {
    const [submitted, setSubmitted] = useState(false);
    const [name, setName] = useState('');

    const handleSubmit = (values) => {
        setName(values.name);
        setSubmitted(true);
    };

    return (
        <div style={{
            minHeight: '100vh',
            overflowY: 'auto',
            background: '#f5f5f5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 16px',
        }}>
            <div style={{
                width: '100%',
                maxWidth: 420,
                background: '#fff',
                borderRadius: 12,
                padding: '40px 36px',
                boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            }}>
                <img
                    src={require('../../assets/logo_color.png')}
                    alt="Heliosfera Energias"
                    style={{ width: '55%', display: 'block', margin: '0 auto 28px' }}
                />

                <Title level={3} style={{ textAlign: 'center', marginBottom: 6 }}>
                    Criar nova conta
                </Title>
                <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: 28 }}>
                    Preencha os dados para solicitar acesso
                </Text>

                {!submitted ? (
                    <Form layout="vertical" onFinish={handleSubmit}>
                        <Form.Item
                            name="name"
                            rules={[{ required: true, message: 'Informe seu nome' }]}
                        >
                            <Input
                                prefix={<UserOutlined style={{ color: '#bbb' }} />}
                                placeholder="Seu nome completo"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item
                            name="email"
                            rules={[
                                { required: true, message: 'Informe seu e-mail' },
                                { type: 'email', message: 'E-mail inválido' },
                            ]}
                        >
                            <Input
                                prefix={<MailOutlined style={{ color: '#bbb' }} />}
                                placeholder="seu@email.com"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            rules={[
                                { required: true, message: 'Informe uma senha' },
                                { min: 6, message: 'Mínimo de 6 caracteres' },
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined style={{ color: '#bbb' }} />}
                                placeholder="Senha"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item
                            name="confirmPassword"
                            dependencies={['password']}
                            rules={[
                                { required: true, message: 'Confirme sua senha' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('As senhas não coincidem'));
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined style={{ color: '#bbb' }} />}
                                placeholder="Confirmar senha"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item style={{ marginBottom: 12 }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                block
                                size="large"
                                style={{ background: '#FB8500', borderColor: '#FB8500' }}
                            >
                                Solicitar acesso
                            </Button>
                        </Form.Item>

                        <div style={{ textAlign: 'center' }}>
                            <Text type="secondary">
                                Já tem conta?{' '}
                                <Link to="/login">Fazer login</Link>
                            </Text>
                        </div>
                    </Form>
                ) : (
                    <>
                        <Alert
                            type="success"
                            showIcon
                            message="Solicitação enviada"
                            description={
                                <>
                                    Olá, <strong>{name}</strong>. Sua solicitação foi registrada.
                                    Um administrador irá criar seu acesso e entrará em contato em breve.
                                </>
                            }
                            style={{ marginBottom: 24 }}
                        />
                        <div style={{ textAlign: 'center' }}>
                            <Link to="/login">
                                <ArrowLeftOutlined style={{ marginRight: 6 }} />
                                Voltar para o login
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Register;
